import { SingleRowAction, MultiRowAction, SelectAllAction, CRMSelectAllOptions } from '@galaxy/crm/static';
import { Row } from '@vendasta/galaxy/table';
import { EmailWorkflowService } from './email-workflow.service';
import { EmailProvider } from './send-email/constants';

export function EmailSingleRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
): SingleRowAction {
  return {
    label: label,
    callback: (row) => {
      service.openEmailComposerFromRows(namespace, userId, [row], provider);
    },
  };
}

export function EmailMultiRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
): MultiRowAction {
  return {
    label: label,
    callback: (rows) => {
      service.openEmailComposerFromRows(namespace, userId, rows, provider);
    },
  };
}

export function EmailSelectAllRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
): SelectAllAction {
  return {
    label: label,
    callback: (rows: Row[], _options?: CRMSelectAllOptions) => {
      service.openEmailComposerFromRows(namespace, userId, rows, provider);
    },
  };
}

